import { Button, Form, Input } from 'antd';
import { useEffect } from 'react';
import type { AppSettings } from '@/types/settings';
import styles from '../Settings.module.scss';

const { TextArea } = Input;

export interface ContactSettingsValues {
  contactEmail: string;
  contactPhone: string;
  address: string;
}

interface ContactConfigTabProps {
  settings?: AppSettings;
  loading?: boolean;
  onSave: (values: ContactSettingsValues) => Promise<void>;
}

export function ContactConfigTab({ settings, loading, onSave }: ContactConfigTabProps) {
  const [form] = Form.useForm<ContactSettingsValues>();

  useEffect(() => {
    if (settings?.website) {
      form.setFieldsValue({
        contactEmail: settings.website.contactEmail,
        contactPhone: settings.website.contactPhone,
        address: settings.website.address,
      });
    }
  }, [form, settings?.website]);

  return (
    <div>
      <h2 className={styles.sectionTitle}>Contact us</h2>
      <p className={styles.sectionDesc}>
        Manage contact details shown on the website footer, contact page, and customer emails.
      </p>

      <Form form={form} layout="vertical" disabled={loading} onFinish={onSave} requiredMark={false}>
        <div className={styles.formGrid}>
          <Form.Item
            label="Contact email"
            name="contactEmail"
            rules={[{ type: 'email', message: 'Enter a valid email address.' }]}
          >
            <Input type="email" placeholder="hello@betiyan.com" />
          </Form.Item>

          <Form.Item label="Contact phone" name="contactPhone">
            <Input placeholder="9876543210" />
          </Form.Item>

          <Form.Item className={styles.fullWidth} label="Business address" name="address">
            <TextArea rows={4} placeholder="Street, city, state, pin code" />
          </Form.Item>
        </div>

        <div className={styles.actions}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save contact details
          </Button>
        </div>
      </Form>
    </div>
  );
}
